import { Component, OnInit } from '@angular/core';
import { CardManagementService } from '../card-management.service';

@Component({
  selector: 'app-card-management-page',
  templateUrl: './card-management-page.component.html',
  styleUrls: ['./card-management-page.component.css']
})
export class CardManagementPageComponent implements OnInit {

  constructor(private cardService: CardManagementService) { }

  cards;

  ngOnInit() {
    this.cards = this.cardService.get();
  }

  add(card) {
    this.cardService.post(card);
  }

  delete(card) {
    this.cardService.delete(card);
  }

}
